import { PermsServiceClient } from '@playq/octopus2-auth';

import { transport } from '../../core';

export const permsService = new PermsServiceClient(transport);
